import { fullSettlement } from "@api/stores/customers/salesInvoices/fullSettlement/api";
import { summery } from "@api/stores/customers/salesInvoices/summery/api";
import { createGetAllApi } from "@api/util/createGetAllApi";

import type { IApiResponse, IPagination, IPaginationParams } from "@api";

import type { IPathBaseParam } from "./path";
import type {
  ICostumersSalesInvoicesResponse,
  ICustomerSalesInvoicesGetAllParams,
} from "./types";

const getAllApis = createGetAllApi<
  IApiResponse<IPagination<ICostumersSalesInvoicesResponse>>,
  IPathBaseParam,
  IPaginationParams & ICustomerSalesInvoicesGetAllParams
>("stores.customers.salesInvoices");

export const salesInvoices = {
  ...getAllApis,
  fullSettlement,
  summery,
};
